/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiExcelExcelMonthlySeparationGet$Params {
  plantilla_ids?: Array<string>;
}

export function apiExcelExcelMonthlySeparationGet(http: HttpClient, rootUrl: string, params?: ApiExcelExcelMonthlySeparationGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, apiExcelExcelMonthlySeparationGet.PATH, 'get');
  if (params) {
    rb.query('plantilla_ids', params.plantilla_ids, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

apiExcelExcelMonthlySeparationGet.PATH = '/api/Excel/Excel_MonthlySeparation';
